export default function Forbidden() {
  return (
    <div style={{ padding: 24 }}>
      <h2>403 - Forbidden</h2>
      <p>Bu səhifəyə giriş icazən yoxdur.</p>
    </div>
  );
}
